'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationName$package$OrganizationName$() {
  this.aDo = null;
  this.aDp = false;
}
export { $c_Lapp_data_OrganizationName$package$OrganizationName$ as $c_Lapp_data_OrganizationName$package$OrganizationName$ };
$p = $c_Lapp_data_OrganizationName$package$OrganizationName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_OrganizationName$package$OrganizationName$;
/** @constructor */
function $h_Lapp_data_OrganizationName$package$OrganizationName$() {
}
export { $h_Lapp_data_OrganizationName$package$OrganizationName$ as $h_Lapp_data_OrganizationName$package$OrganizationName$ };
$h_Lapp_data_OrganizationName$package$OrganizationName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aDp)) {
    this.aDo = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aDp = true;
  }
  return this.aDo;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_OrganizationName$package$OrganizationName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationName$package$OrganizationName$, "app.data.OrganizationName$package$OrganizationName$", ({
  Es: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_OrganizationName$package$OrganizationName$ as $d_Lapp_data_OrganizationName$package$OrganizationName$ };
var $n_Lapp_data_OrganizationName$package$OrganizationName$;
function $m_Lapp_data_OrganizationName$package$OrganizationName$() {
  if ((!$n_Lapp_data_OrganizationName$package$OrganizationName$)) {
    $n_Lapp_data_OrganizationName$package$OrganizationName$ = new $c_Lapp_data_OrganizationName$package$OrganizationName$();
  }
  return $n_Lapp_data_OrganizationName$package$OrganizationName$;
}
export { $m_Lapp_data_OrganizationName$package$OrganizationName$ as $m_Lapp_data_OrganizationName$package$OrganizationName$ };
//# sourceMappingURL=app.data.-Organization-Name$package$-Organization-Name$.js.map
